export default __webpack_public_path__ + "static/media/welcomeModal.f4357d80.png";